module.exports = __webpack_public_path__ + "static/media/ico_uncheck.cc60b338.svg";